import React from 'react';
import CancelLiquidation from 'components/Tvendo/Distribution/Operations/CancelLiquidation/List';

export default function () {
  return <CancelLiquidation />;
}
